<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>
</ng-container>
<ng-container>
  <div style="text-align: center; padding-top: 30px">
    <div style="text-align: center">
      <h3>Contatta il medico</h3>
    </div>
    <div style="padding: 10px"></div>
    <app-box title="Manda un nuovo questionario" route="/choose-questionnaire" image="patients.png"></app-box>
    <div style="padding: 10px"></div>
    <app-box title="Scrivi al dottore" route="/patient-chat" image="chatIcon.png"></app-box>
    <div style="padding: 10px"></div>
  </div>
</ng-container>
